import clsx from 'clsx';
import { Link } from 'react-router';

export function Button({
  children,
  className,
  disabled,
  type = 'button',
  variant = 'primary',
  to,
  ...props
}) {
  const variants = {
    primary:
      'bg-primary text-white border-transparent hover:bg-primary-hover active:bg-primary-active hover:text-white',
    'primary-light':
      'bg-primary-100 text-primary-hover hover:bg-primary-hover active:bg-primary-active hover:text-white active:text-white',
    outlined:
      'bg-white text-body border-light-300 hover:text-body hover:bg-light-hover active:bg-light-active',
  };

  const commonClasses = clsx(
    'inline-block w-full text-center rounded-md px-3 py-2 border border-solid font-medium shadow-sm transition-colors disabled:opacity-60 disabled:pointer-events-none',
    variants[variant],
    className,
  );

  if (to) {
    return (
      <Link
        to={to}
        className={clsx(commonClasses, {
          'opacity-60 pointer-events-none': disabled,
        })}
        {...props}
      >
        {children}
      </Link>
    );
  }

  return (
    <button type={type} className={commonClasses} disabled={disabled} {...props}>
      {children}
    </button>
  );
}
